var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallGoldbarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.45041L14.7942 3.04409L10.4111 0.5L1.32823 5.66928L0 9.45829L5.35446 12.5L5.44243 8.3773L1.27687 5.83787L1.6342 6.03972L1.43041 5.91429L2.15817 6.32732L1.49597 5.91429L5.60852 8.28629L14.462 3.39937L13.0447 4.23009L14.704 3.32528L11.4198 5.18216L5.71889 8.52314L5.35446 12.5L16 6.45041ZM5.78555 7.09679L3.38752 5.73053L5.71998 6.50058L12.8611 3.11702L5.78555 7.09679Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGoldbarIcon);
export default __webpack_public_path__ + "static/media/small_goldbar_icon.80cc18b752bfd0368e5089eacba1d15e.svg";
export { ForwardRef as ReactComponent };